module.exports = __webpack_public_path__ + "static/img/zhichi.8bb2f15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhichi.png
// module id = 03xm
// module chunks = 6